
// import TopHeader from "../../../../components/general/TopHeader";

// import UserAnalyticsTab from "./UserAnalyticsTabs/UserAnalyticsTabs";


// export default function UserAnalytics() {
//     return (
//         <>
//             <TopHeader />
//             <UserAnalyticsTab />
//         </>
//     )
// }


import { Box, Breadcrumbs, Card, CardContent, CardMedia, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'

import { Nav, Tab, Tabs } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';

import TopHeader from "../../../../components/general/TopHeader";

import UserAnalyticsTab1 from './UserAnalyticsTabs/UserAnalyticsTab1/UserAnalyticsTab1';
import UserAnalyticsTab2 from './UserAnalyticsTabs/UserAnalyticsTab2/UserAnalyticsTab2';
import InvCufPerformance from './UserAnalyticsTabs/invCufPerformance/InvCufPerformance';
import InvPrPerformance from './UserAnalyticsTabs/invPrPerformance/InvPrPerformance';
import UserAnalyticsTab3 from './UserAnalyticsTabs/UserAnayticsTab3/UserAnalyticsTab3';
import UserAnalyticsTab4 from './UserAnalyticsTabs/UserAnalyticsTab4/UserAnalyticsTab4';
import UserAnalyticsTab5 from './UserAnalyticsTabs/UserAnalyticsTab5/UserAnalyticsTab5';


export default function UserAnalytics() {
    const { palette, typography, breakpoints, spacing } = useTheme()
    const matches = useMediaQuery(breakpoints.up('lg'));


    const [key, setKey] = useState('General Comparison');
    const location = useLocation();
    function handleClick(event) {
        event.preventDefault();
        console.info('You clicked a breadcrumb.');
    }

    return (
        <Box>
            <CssBaseline />
            <TopHeader />
            <Box mt={spacing(1)}>
                <Stack direction={'row'} sx={{ position: 'absolute', columnGap: spacing(1) }} role="presentation" onClick={handleClick}>
                    <NavLink style={{ textDecoration: "none", color: palette.primary.main }}>
                        {/* Business Dashboard */}
                    </NavLink>
                    <NavLink style={{ textDecoration: "none", color: palette.primary.main }}>
                        {/* {location.pathname} */}
                    </NavLink>
                </Stack>
                <Tabs
                    style={{ justifyContent: "flex-end" }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >



                    <Tab eventKey="General Comparison" title="General Comparison">

                        <UserAnalyticsTab1 />
                    </Tab>

                    <Tab eventKey="Parameter Comparison" title="Parameter Comparison">

                        <UserAnalyticsTab2 />
                    </Tab>

                    <Tab eventKey="Inverter Wise CUF Comparison" title="Inverter Wise CUF Comparison">
                    <InvCufPerformance/>
                    </Tab>

                    <Tab eventKey="Inverter Wise PR Comparison" title="Inverter Wise PR Comparison">
                    <InvPrPerformance/>
                    </Tab>

                    <Tab eventKey="CUF Analysis" title="CUF Analysis">
                    <UserAnalyticsTab3/>
                    </Tab>

                    <Tab eventKey="PR Analysis" title="PR Analysis">
                    <UserAnalyticsTab4/>
                    </Tab>

                    <Tab eventKey="Specific Yield Analysis" title="Specific Yield Analysis">
                    <UserAnalyticsTab5/>
                    </Tab>

                </Tabs>
            </Box>
        </Box>

    )
}
